import UpdateSafetyAnchorPointRequestModelBase from '../_generated/modelBases/update-safety-anchor-point-request-model-base';

export default class UpdateSafetyAnchorPointRequestModel extends UpdateSafetyAnchorPointRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
